/** @format */

// import { findTreeDataByAll, findTreeDataByThePos, findTreeDataByPos } from '@/api/platform/org/position'
import { TreeUtils } from '@/utils/tree';
import { $utils } from '@/utils/publicUtils';
import { findTreeData as findTreeDataByAll } from '@/api/position/index';
import { ActionUtils } from '@/utils/action';

export default {
	methods: {
		findTreeDataTypes(type, paramsOptions, methods, invokingType = '', extraOptions) {
			return new Promise((resolve, reject) => {
				switch (type) {
					case '1':
						methods
							.findTreeDataByAll(paramsOptions, invokingType)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '2':
						methods
							.findTreeDataByThePos(paramsOptions, invokingType, extraOptions)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '3':
						methods
							.findTreeDataByPos(paramsOptions, invokingType, extraOptions)
							.then((res) => {
								resolve(res);
							})
							.catch(() => {
								reject([]);
							});
						break;
				}
			});
		},
		// 查询全部-1
		findTreeDataByAll(paramsOptions, invokingType) {
			const params = invokingType === 'init' ? paramsOptions : {};
			if (invokingType !== 'init') {
				if (paramsOptions.moreSearchParams) {
					Object.assign(params, paramsOptions.moreSearchParams);
				}
				// 范围选择器调用
				params.includeSub = true;
				params.posId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
			}
			return new Promise((resolve, reject) => {
				findTreeDataByAll(ActionUtils.formatParams(params))
					.then((res) => {
						const treeData = this.conformityData(paramsOptions, res, '1', invokingType);
						resolve(treeData);
					})
					.catch(() => {
						reject([]);
					});
			});
		},
		// 查询当前-2
		// findTreeDataByThePos(paramsOptions, invokingType, extraOptions = {}) {
		// 	const params = invokingType === 'init' ? paramsOptions : {};
		// 	if (invokingType !== 'init') {
		// 		if (paramsOptions.moreSearchParams) {
		// 			Object.assign(params, paramsOptions.moreSearchParams);
		// 		}
		// 		params.includeSub = extraOptions.includeSub;
		// 		params.posId = paramsOptions.node.level === 0 ? null : paramsOptions.node.data.id;
		// 	}
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByThePos(params)
		// 			.then((res) => {
		// 				const treeData = this.conformityData(paramsOptions, res.data, '2', invokingType, extraOptions.includeSub);
		// 				resolve(treeData);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
		// 查询指定-3
		// findTreeDataByPos(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByPos(params)
		// 			.then((res) => {
		// 				resolve(res);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
		conformityData(paramsOptions, res, type, invokingType, includeSub) {
			let data = res;
			if (invokingType === 'node') {
				const nodeData = paramsOptions.node.data;
				if ($utils.isEmpty(nodeData) || nodeData.id === '0') {
					if ($utils.isEmpty(nodeData)) {
						data = this.toTree(res);
					} else {
						const datas =
							type !== '2' ? res : this.filterPositionTreeChildren(res, 'root', paramsOptions.partyId, includeSub);
						data = datas;
					}
				} else if ($utils.isArray(nodeData) && nodeData[0].id === '0') {
					data = this.toTree(res);
				} else {
					const datas = type !== '2' ? res : res.filter((a) => a.parentId === nodeData.id);

					data = datas;
				}
			}
			return data;
		},
		toTree(data) {
			return TreeUtils.transformToTreeFormat(data, {
				idKey: 'id',
				pIdKey: 'parentId',
				childrenKey: 'children',
			});
		},
		// 根据渲染的数据范围类型，筛选目标节点
		filterPositionTreeChildren(treeData, treeScope, partyId, hasSubset = false) {
			const data = [];
			// 返回设置的范围节点
			if (treeScope === 'root') {
				const currentOrgIds = partyId.split(',');
				treeData.forEach((f) => {
					if (currentOrgIds.includes(f.id)) {
						f.leaf = !hasSubset;
						data.push(f);
					}
				});
			}
			return data;
		},
	},
};
